export const USER_PREFERENCES = 'uiSettings'
export const GET_UI_SETTINGS = 'getUiSettings'
export const POST_UI_SETTINGS = 'postUiSettings'
export const APP_SETTINGS = 'APP_SETTINGS'
